export function getContrastColor(hexcolor: string): string {
  hexcolor = hexcolor.replace('#', '');

  const r = parseInt(hexcolor.substring(0, 2), 16);
  const g = parseInt(hexcolor.substring(2, 4), 16);
  const b = parseInt(hexcolor.substring(4, 6), 16);

  const [rl, gl, bl] = [r, g, b].map((value) => {
    const sRGB = value / 255;
    return sRGB <= 0.03928
      ? sRGB / 12.92
      : Math.pow((sRGB + 0.055) / 1.055, 2.4);
  });

  const luminance = 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;

  const contrastThreshold = 0.379;

  return luminance > contrastThreshold ? '#000000' : '#ffffff';
}
